import { LocalDate } from '../../../utilities/local-date';
import type { SubPeriodWithMinutes } from './sub-period-with-minutes';
import { timeInMinutes } from './time-in-minutes';
import { sortBy } from 'lodash';

export function getSubPeriodsWithMinutes(
  periods: { start: string; startTime?: string; end: string; endTime?: string; type?: string }[],
  yearStartDate: LocalDate,
): SubPeriodWithMinutes[] {
  const oPeriods = periods.map((period) => {
    const startDate = LocalDate.fromString(period.start);
    let startMinutes = yearStartDate.until(startDate) * 1440;
    if (period.startTime) {
      startMinutes += timeInMinutes(period.startTime);
    }
    const endDate = LocalDate.fromString(period.end);
    let endMinutes = yearStartDate.until(endDate) * 1440;
    if (period.endTime) {
      endMinutes += timeInMinutes(period.endTime);
    } else {
      endMinutes += 1440;
    }
    return {
      start: period.start,
      end: period.end,
      startMinutes: startMinutes,
      endMinutes: endMinutes,
      type: 'type' in period ? (period.type ?? '') : 'plusTime',
    };
  });
  return sortBy(oPeriods, [(e) => e.startMinutes]);
}
